import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import TableHelper from '../../../components/TableHelper'
import { fetchTransferRecordLogFlowList } from '../../../services/transferRecordLog'
import { findDict, formatTime } from '../../../utils'
/**
 * 划账 - 流程审批记录
 */
const TransferRecordFlowListModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [transferRecordLogId, setTransferRecordLogId] = useState(null);
    const mapStatus = [
        { title: '通过', value: 1 },
        { title: '不通过', value: 2 },
        { title: '待审核', value: 3 },
    ]
    const columns = [
        { title: '接收人', dataIndex: 'receiverByName', width: 100 },
        { title: '状态', dataIndex: 'status', width: 100, render: (text) => {
            return findDict(mapStatus, text).title
        } },
        { title: '备注信息', dataIndex: 'remarks', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', width: 100, render: formatTime },
        { title: '审核时间', dataIndex: 'updateTime', width: 100,render: (_, record) => {
            if(record.status!=3){
                return formatTime(record.updateTime || record.updateTime, 'YYYY-MM-DD HH:mm:ss')
            }else{
                return null;
            }

        } },
    ]
    const open = (id) => {
        setVisible(true)
        setTransferRecordLogId(id)
    }
    const close = () => {
        setVisible(false)
    }
    const parseRequestData = (req) => {
        req.transferRecordLogId = transferRecordLogId
        return req
    }
    const parseResponse = (res = []) => {
        const dataSource = res.map((e, i) => {
            e.id = i
            return e
        })
        return { dataSource,  total: res.length }
    }
    props.getRef && (props.getRef({open}))
    return (
        <Modal 
            title="流程审批列表" 
            width={800}
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
            {(visible && transferRecordLogId) && (
                <div style={{padding:20}}>
                    <TableHelper 
                        parseRequestData={parseRequestData}
                        parseResponse={parseResponse}
                        request={fetchTransferRecordLogFlowList}
                        columns={columns}
                    />
                </div>
            )} 
        </Modal>
    )
}

export default TransferRecordFlowListModal


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/components/FlowListModal.jsx